import AddIntegration from './AddIntegration'
import IntegrationCard from './IntegrationCard'
import StateBlock from './StateBlock'
import type { ParkDetail } from '../lib/types'

export default function IntegrationsTab({ slug, detail }: { slug: string; detail: ParkDetail }) {
  return (
    <>
      {detail.integrations.length === 0 ? (
        <StateBlock
          kind="empty"
          message="Nog geen koppeling. Zonder koppeling toont de kaart geen beschikbaarheid en geen boekknop."
        />
      ) : (
        detail.integrations.map((integration) => (
          <IntegrationCard key={integration.id} slug={slug} integration={integration} unitCount={detail.units.length} />
        ))
      )}
      <AddIntegration slug={slug} existing={detail.integrations.map((integration) => integration.connector)} />
    </>
  )
}
